import React, { useLayoutEffect, useMemo } from "react";
import EpisodesSkeleton from "../Home/EpisodesSkeleton";

const SeasonEpisodeCombineSkeleton: React.FC<{ type: "episode" | "music" }> = ({
  type,
}) => {
  const getEpisodesSkeletonArray = useMemo(() => {
    if (window.innerWidth < 768) {
      return [1];
    }
    if (window.innerWidth < 1280) {
      return [1, 2];
    }
    return [1, 2, 3];
  }, []);

  const getSkeletonArray = useMemo(() => {
    return window.innerWidth < 768 ? [1, 2] : [1, 2, 3, 4, 5, 6];
  }, []);

  useLayoutEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }, []);

  if (type === "episode") {
    return (
      <div className="container !px-4 pt-[65px] max-md:pt-6 mb-10 min-h-[800px]">
        <h2 className="text-lightBlue text-6xl max-md:text-4xl max-sm:text-3xl text-start mb-8 max-sm:mb-6 break-all">
          Fatsu <span className="text-primary">Episodes</span>
        </h2>
        <div className="flex gap-6">
          {getSkeletonArray.map((val) => {
            return <div className="skeleton w-[118px] h-10" key={val}></div>;
          })}
        </div>
        <div
          className={`grid ${
            window.innerWidth < 768
              ? "grid-cols-1 mx-auto"
              : window.innerWidth < 1280
              ? "grid-cols-2"
              : "grid-cols-3"
          } gap-8 items-start z-[1] mt-6`}
        >
          {getEpisodesSkeletonArray.map((val) => {
            return <EpisodesSkeleton key={val} />;
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div className="container  pt-10 max-md:pt-6 pb-6">
        <h2 className="text-lightBlue text-6xl max-md:text-4xl max-sm:text-3xl text-start mb-8 max-sm:mb-6 break-all">
          Fatsu <span className="text-primary">Music</span>
        </h2>

        <div
          className={`grid ${
            window.innerWidth < 768
              ? "grid-cols-1 mx-auto"
              : window.innerWidth < 1280
              ? "grid-cols-2"
              : "grid-cols-3"
          } gap-8 items-start z-[1] mt-6`}
        >
          {getEpisodesSkeletonArray.map((val) => {
            return <EpisodesSkeleton key={val} />;
          })}
        </div>
      </div>
    );
  }
};

export default SeasonEpisodeCombineSkeleton;
